(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants', '$scope', 'MessageService', 'VerifyCode',
     '$interval', 'Customer', '$state', '$stateParams', "$cookieStore", "$translate"];

    function RequestResetController ($timeout, Auth, errorConstants, $scope, MessageService, VerifyCode,
     $interval, Customer, $state, $stateParams, $cookieStore, $translate) {
        var vm = this;

        vm.error = null;
        vm.resetPassword = resetPassword;
        $scope.paracont = $translate.instant("resetPassword.getVerifyCode");
        vm.storeId = $stateParams.storeId|| $cookieStore.get("store-id");
        if (!vm.storeId) {
            return;
        }
        vm.success = null;
        vm.checkCode = false;
        var timer = null;
        $(".navbar").hide();
        $(".wrap").css({margin:0})

        $timeout(function (){angular.element('#email').focus();});

        $scope.checkVerifyCode = function(){ 
            VerifyCode.check({
                storeId:vm.storeId,
                phone: vm.registerAccount.phone,
                code: vm.registerAccount.code,
            }, function (msg) {
                if (msg.status == 200 && msg.message==true) {
                    vm.checkCode = true;
                }else{
                    vm.checkCode = false;
                   MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
                }
            },function(){
                vm.checkCode = false;
                MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
            });
        }


        $scope.getVerifyCode = function () {
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                MessageService.error($translate.instant("resetPassword.enterPhoneFirst"));
                return;
            }
            if (vm.disabled) {
                return;
            }
            vm.countdown = 120;
            // 发送验证码到手机
            VerifyCode.getVerifyCode({
                phone: vm.registerAccount.phone,
                storeId:vm.storeId,
                incident: "忘记密码"
            }, function (msg) {
                clearInterval(timer);
                timer = $interval(function () {
                    if (vm.countdown > 0) {
                        vm.disabled = true;
                        vm.countdown -- ;
                        $scope.paracont = $translate.instant("resetPassword.resendVerifyCode") + "(" + vm.countdown + ")";
                    } else {
                        vm.disabled = false;
                        $interval.cancel(timer);
                        $scope.paracont = $translate.instant("resetPassword.resendVerifyCode");
                    }
                }, 1000);
            });
        };

        
        function resetPassword () {
            vm.error = null;
            var postData = { 
                phone:vm.registerAccount.phone,
                password:vm.registerAccount.password,
                storeId:vm.storeId
            }
            Customer.changePassword(postData,
                function(data) {
                    MessageService.success($translate.instant("resetPassword.resetSuccess"));
                    $state.go("home", {storeId:vm.storeId});
                },
                function() {
                    MessageService.error($translate.instant("resetPassword.resetFailed"));
                });
        }
    }
})();
